import { useCallback, useEffect, useState } from "react";
import {
  MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle,
  MDBModalBody, MDBModalFooter, MDBBtn, MDBInput, MDBTextArea, MDBCheckbox
} from "mdb-react-ui-kit";
import "./ExhibicionCreateModal.css";

import { doFetchJson } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";

export default function ExhibicionCreateModal({ show, setShow, onCreated, hostAppCode = null, registeredApps = [] }) {
  const [titulo, setTitulo] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [apps, setApps] = useState([]);
  const [selectedApps, setSelectedApps] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show) {
      loadApps();
      // Pre-seleccionar el hostAppCode si está definido
      setSelectedApps(hostAppCode ? [hostAppCode] : []);
    }
  }, [show, hostAppCode]);

  async function loadApps() {
    console.log("[EXHI:CreateModal] loadApps");
    try {
      const res = await doFetchJson("EXHI", "apps", { method: "GET" });
      console.log("[EXHI:CreateModal] loadApps — respuesta:", res?.STATE, "apps:", res?.DATA?.length);
      if (res && res.STATE === "SUCCESS") setApps(res.DATA || []);
    } catch (err) {
      console.error("[EXHI:CreateModal] loadApps — ERROR:", err);
      // no bloquea
    }
  }

  function toggleApp(appCode) {
    setSelectedApps((prev) =>
      prev.includes(appCode) ? prev.filter((a) => a !== appCode) : [...prev, appCode]
    );
  }

  async function handleSave() {
    if (!titulo.trim()) {
      toast.show({ message: "El título es obligatorio", type: "warning" });
      return;
    }
    setSaving(true);
    try {
      const body = new URLSearchParams();
      body.append("titulo", titulo.trim());
      body.append("descripcion", descripcion.trim());
      body.append("appCodes", selectedApps.join(","));
      console.log(`[EXHI:CreateModal] handleSave — titulo="${titulo}" appCodes=[${selectedApps.join(",")}]`);

      const res = await doFetchJson("EXHI", "exhibiciones", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      console.log("[EXHI:CreateModal] handleSave — respuesta:", res?.STATE, res?.MESSAGE, "id:", res?.DATA?.idExhibicion);
      if (res && res.STATE === "SUCCESS") {
        toast.show({ message: "Exhibición creada correctamente", type: "success" });
        onCreated && onCreated(res.DATA);
      } else {
        toast.show({ message: res?.MESSAGE || "Error al crear la exhibición", type: "danger" });
      }
    } catch (err) {
      console.error("[EXHI:CreateModal] handleSave — ERROR:", err);
      toast.show({ message: "Error de conexión", type: "danger" });
    } finally {
      setSaving(false);
    }
  }

  const handleClose = useCallback(() => {
    setTitulo("");
    setDescripcion("");
    setSelectedApps(hostAppCode ? [hostAppCode] : []);
    setShow(false);
  }, [hostAppCode, setShow]);

  return (
    <MDBModal show={show} onHide={handleClose} tabIndex="-1">
      <MDBModalDialog>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>Nueva exhibición</MDBModalTitle>
            <MDBBtn className="btn-close" color="none" onClick={handleClose} />
          </MDBModalHeader>
          <MDBModalBody>
            <div className="mb-3">
              <MDBInput
                label="Título"
                value={titulo}
                onChange={(e) => setTitulo(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <MDBTextArea
                label="Descripción (opcional)"
                rows={3}
                value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
              />
            </div>
    {apps.length > 0 && (
              <div>
                <small className="text-muted d-block mb-2">Apps asociadas:</small>
                <div className="exhi-create-modal-apps">
                  {apps
                    .filter((a) =>
                      registeredApps.length === 0 || registeredApps.includes(a.appCode)
                    )
                    .map((a) => (
                      <MDBCheckbox
                        key={a.appCode}
                        label={a.nombre}
                        checked={selectedApps.includes(a.appCode)}
                        onChange={() => toggleApp(a.appCode)}
                        disabled={hostAppCode === a.appCode}
                      />
                    ))}
                </div>
              </div>
            )}
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="secondary" onClick={handleClose} disabled={saving}>
              Cancelar
            </MDBBtn>
            <MDBBtn onClick={handleSave} disabled={saving}>
              {saving ? "Guardando..." : "Crear"}
            </MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}
